var _circle, _rect, _mask, _rect2, _mask2, _rect3, _mask3, _rect4, _mask4, _rect5, _mask5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    fill: "#FF5F14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 49.21,
    width: 83.62,
    height: 49.58,
    rx: 2.59,
    fill: "#FF5F14",
    stroke: "white",
    strokeWidth: 5.18
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.48,
    y: 56.24,
    width: 50.32,
    height: 5.92,
    rx: 0.74
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.48,
    y: 56.24,
    width: 50.32,
    height: 5.92,
    rx: 0.74,
    fill: "white",
    stroke: "white",
    strokeWidth: 5.92,
    mask: "url(#path-3-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.48,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.48,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74,
    fill: "white",
    stroke: "white",
    strokeWidth: 4.44,
    mask: "url(#path-4-inside-2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74,
    fill: "white",
    stroke: "white",
    strokeWidth: 4.44,
    mask: "url(#path-5-inside-3)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.96,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.96,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74,
    fill: "white",
    stroke: "white",
    strokeWidth: 4.44,
    mask: "url(#path-6-inside-4)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.72,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57.72,
    y: 85.1,
    width: 13.32,
    height: 4.44,
    rx: 0.74,
    fill: "white",
    stroke: "white",
    strokeWidth: 4.44,
    mask: "url(#path-7-inside-5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditApplicationIcon);
export default __webpack_public_path__ + "static/media/creditApplicationIcon.e3be21c4357cb944b640f236ebec7e8b.svg";
export { ForwardRef as ReactComponent };